import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { ReactSession } from 'react-client-session';
import {Helmet} from "react-helmet";
// import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import { PayPalButton } from "react-paypal-button-v2";

import '../Dashboard.css';
import classes from "./Payment.module.css";
import styles from '../Dashboard.module.css';

import Header from "../Header/Header";
import Sidebar from "../Sidebar/Sidebar";
import Footer from "../../Footer/Footer";

function Home() {
    const navigate = useNavigate();
    const [options, setOptions] = useState([]);
    const [validity, setValidity] = useState(1);
    const [price, setPrice] = useState(0);
    ReactSession.setStoreType("localStorage");
    const logged_user = ReactSession.get('logged_user');

    const getOptions = () => {
        const data = new FormData();
        data.append('option_name[]', 'monthlyprice');
        data.append('option_name[]', 'monthlycurrency');
        axios.post(`${process.env.REACT_APP_API_URL}/api/get_option.php`, data, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
        }).then((res) => {
        // console.log(res.data);
        setOptions(res.data);
        setPrice(res.data.monthlyprice)
        })
    }

    useEffect(() => {
        getOptions();
    }, [])

    const getSubsPrice = (e) => {
        setPrice(options.monthlyprice * e);
        setValidity(e)
    }

    return (
        <>
            <Helmet>
                <title>Payment</title>
            </Helmet>
            <div className="container_wrapper">
                <Header />
                <div className={`${styles.main} main`}>
                    <Sidebar active="dashboard" />
                    <div className={styles.main_content}>
                        <div className={styles.content_body}>
                            <div className={classes.isBoxed}>
                                <h3>Get premium</h3>
                                <h4>Get a cool premium badge, access to oremium videos, remove ads and get other benefits!</h4>
                                <p className="block mtop20">
                                    <span>Choose Validity:</span>
                                    <select name="validity" onChange={(e) => getSubsPrice(e.target.value)}>
                                        <option value="1" selected="selected">1 Month</option>
                                        <option value="2">2 Months</option>
                                        <option value="3">3 Months</option>
                                        <option value="6">6 Months</option>
                                        <option value="9">9 Months</option>
                                        <option value="12">Full Year</option>
                                    </select>
                                </p>
                                <p>Price: <span id={classes.subPrice} className="badge">{price} {options.monthlycurrency}</span></p>
                            </div>
                            <div className={classes.divider}></div>
                            <div className={classes.payment_area}>
                                <h6>Click to checkout and make payment.</h6>
                                <PayPalButton
                                    options={{
                                        clientId: process.env.REACT_APP_PAYPAL_CLIENT_ID,
                                        currency: "GBP",
                                    }}
                                    amount={price || '50'}
                                    onSuccess={(details, data) => {
                                        // alert("Transaction completed by " + details.payer.name.given_name);

                                        // console.log({ details, data });

                                        let formData = new FormData();
                                        formData.append('order_id', details.id);
                                        formData.append('status', details.status);
                                        formData.append('email_address', details.payer.email_address);
                                        formData.append('amount', details.purchase_units[0].amount.value);
                                        formData.append('currency_code', details.purchase_units[0].amount.currency_code);
                                        formData.append('user_id',logged_user);
                                        formData.append('validity', validity);

                                        // let formObject = Object.fromEntries(formData.entries());
                                        // console.log(formObject);

                                        axios.post(`${process.env.REACT_APP_API_URL}/api/user/payment.php`, formData, {
                                            headers: {
                                                'Content-Type': 'multipart/form-data',
                                            }
                                        }).then(res => {
                                            // console.log(res.data);
                                            if(res.data.status === 'success') {
                                                navigate('/dashboard/subscriptions');
                                            }
                                        })
                                    }}
                                />
                            </div>
                        </div>
                        <Footer />
                    </div>
                </div>
            </div>
        </>
    );
}

export default Home;